export enum eTextColor {
    Black = 'text-color-black',
    White = 'text-color-white',
}
